import { DataType } from 'components/BasicTable/types';

export type BankAccount = {
	id: number;
	companyId?: number;
	iban?: string;
	status?: string;
	accountOwnerName: string;
	reference: string;
	bankOrigin?: string;
	bankBranch: string;
	accountNumber: string;
	bankName: any;
	currencyId: number;
	bank?: any;
	currency?: any;
	accountBankId?: any;
	createdAt?: Date;
	updatedAt?: Date;
	deletedAt?: Date;
	IsDigitalDepositSupported?: boolean;
};

export type BankAccountRequest = {
	referenceNumber: string;
	date: string;
	holderName: string;
	bankName: string;
	branch: string;
	accountNumber: string;
};

export const BankAccountId: keyof BankAccount = 'id';

export const BankAccountDefaultSort: keyof BankAccount = 'accountOwnerName';

export const BankAccountRequestTableColumns: { [key: string]: DataType } = {
	referenceNumber: 'string',
	date: 'date',
	holderName: 'string',
	bankName: 'string',
	branch: 'string',
	accountNumber: 'string',
	//createdBy: 'string',
};

export const BankAccountTableColumns: {
	[key in keyof Partial<BankAccount>]: DataType;
} = {
	accountOwnerName: 'string',
	bankName: 'string',
	bankBranch: 'string',
	accountNumber: 'string',
	reference: 'string',
};

export enum BankAccountColumns {
	accountOwnerName = 'accountOwnerName',
	bankName = 'bankName',
	bankBranch = 'bankBranch',
	accountNumber = 'accountNumber',
	reference = 'reference',
}

export enum BankAccountStatus {
	None = 'None',
	Pending = 'Pending',
	Completed = 'Completed',
	Rejected = 'Rejected',
	Failed = 'Failed',
	Deleted = 'Deleted',
}
